import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { ComponentProps, ForwardedRef, forwardRef } from 'react'
import { Fonts } from '~/assets/style/fonts'
import { TrackingLabel } from '@pubstack/ui/types/tracking'
import { WithClassName } from '~/types/utils'
import { Icon, IconName } from './Icon'

export const LinkLabel = styled.span`
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`
export const LinkIcon = styled(Icon)`
  ${LinkLabel} ~ & {
    margin-left: 2px;
  }
`

const Wrapper = styled.a<{ variant?: LinkProps['variant']; disabled?: boolean }>`
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  text-decoration: none;
  ${Fonts.colors.King};
  font-weight: bold;
  ${({ variant }) => (variant === 'secondary' ? Fonts.P2 : Fonts.P1)};

  display: inline-flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  min-width: 0;

  :hover {
    text-decoration: none;
    ${({ disabled }) => (disabled ? Fonts.colors.SlateGrey : Fonts.colors.Cobalt)};
  }

  :active {
    text-decoration: none;
    ${({ disabled }) => !disabled && Fonts.colors.Navy};
  }

  :visited {
    text-decoration: none;
    ${({ disabled }) => (disabled ? Fonts.colors.SlateGrey : Fonts.colors.King)};
  }

  ${({ disabled }) =>
    disabled &&
    css`
      ${Fonts.colors.SlateGrey};
    `}
`
const IconSizes: { [key in Required<LinkProps>['variant']]: string } = {
  primary: '20px',
  secondary: '18px',
}

type LinkProps = WithClassName &
  ComponentProps<'a'> & {
    label?: string
    icon?: IconName
    iconSize?: string
    variant?: 'primary' | 'secondary'
    trackingLabel: TrackingLabel
    disabled?: boolean
    iconSpin?: boolean
  }

const BaseLink = forwardRef(({ className, icon, iconSpin, label, iconSize, variant, trackingLabel, ...props }: LinkProps, ref: ForwardedRef<HTMLAnchorElement>) => (
  <Wrapper className={className} variant={variant} ref={ref} {...props} data-tracking={trackingLabel}>
    {label && <LinkLabel>{label}</LinkLabel>}
    {icon && <LinkIcon name={icon} spin={iconSpin} width={iconSize ?? IconSizes[variant ?? 'primary']} />}
  </Wrapper>
))
export const Link = styled(BaseLink)``
